let toggleButton = document.getElementById('burger-menu');
let menuContainer = document.getElementById('nav-drawer');
let toggleButtonText = document.getElementById('toggle-btn-text');

toggleButton.addEventListener('click', () => {
    if(toggleButtonText.innerHTML === "Menu") toggleButtonText.innerHTML = "Close"
    else toggleButtonText.innerHTML = "Menu"    
    menuContainer.classList.toggle('hidden');
});





